import { render, staticRenderFns } from "./IriDetailTable.vue?vue&type=template&id=b0f56e82"
import script from "./IriDetailTable.vue?vue&type=script&lang=js"
export * from "./IriDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports